module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$route.query.step == 1) ? _c('step1') : _vm._e(), _vm._v(" "), (this.$route.query.step == 2) ? _c('step2') : _vm._e(), _vm._v(" "), (this.$route.query.step == 3) ? _c('step3') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c31216b4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sellerRequest/SellerRequest.vue
// module id = 734
// module chunks = 0